<template>
  <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark height="100">
    <template v-slot:img="{ props }">
      <v-img
        src="../assets/Background.png"
        v-bind="props"
        position="left left"
      ></v-img>
    </template>
    <v-app-bar-nav-icon @click.stop="triggerDrawer" v-if="currentUserRef.tenantId !== '0'"/>
    <!-- we use style just for align logos -->
    <img src="../assets/PIM_logo.png" @click="openHomePage" class="pointer" style="margin-left: 40px;"/>
    <img src="../assets/Product_IM.png" />
    <v-spacer />
    <img src="../assets/RRR.png" style="height: 52px;" class="pointer"/>
    <img src="../assets/Ritter_logo.png" class="pointer" style="margin-right:8%;margin-left: 8%;"/>
    <img src="../assets/Duwi_logo.png" class="pointer" style="margin-right: 8%; margin-bottom: 25px;"/>
    <AppHeaderSearch :export="isExportSearch" />
    <AfterSearchComponent></AfterSearchComponent>
    <v-menu offset-y v-if="languages.length > 1">
      <template v-slot:activator="{ on }">
        <v-btn class="mr-2" dark text v-on="on">
          {{ currentLanguage ? currentLanguage.identifier : '' }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(lang, index) in languages" :key="index" @click="languageSelected(lang.identifier)">
          <v-list-item-title>{{ lang.name[currentLanguage.identifier] || lang.name[defaultLanguageIdentifier] }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn icon @click="triggerDrawerRight"><v-icon>mdi-alpha-p-circle-outline</v-icon></v-btn>
    <v-btn icon @click="triggerUserDialog"><v-icon>mdi-account</v-icon></v-btn>
    <AfterButtonsComponent></AfterButtonsComponent>
  </v-app-bar>
</template>

<script>
import { onMounted } from '@vue/composition-api'

import * as langStore from '../store/languages'
import * as userStore from '../store/users'

import AppHeaderSearch from '../components/AppHeaderSearch.vue'
import AfterSearchComponent from '../_customizations/toolbar/afterSearch/AfterSearchComponent'
import AfterButtonsComponent from '../_customizations/toolbar/afterButtons/AfterButtonsComponent'
import eventBus from '../eventBus'

export default {
  components: { AppHeaderSearch, AfterSearchComponent, AfterButtonsComponent },
  props: {
    export: {
      type: Boolean,
      required: true
    },
    drawer: {
      required: true
    },
    drawerRight: {
      required: true
    }
  },
  setup (props) {
    const {
      currentUserRef
    } = userStore.useStore()

    const {
      languages,
      currentLanguage,
      defaultLanguageIdentifier,
      loadAllLanguages
    } = langStore.useStore()

    onMounted(() => {
      if (!props.drawer) return
      loadAllLanguages()
    })

    function triggerDrawer () {
      eventBus.emit('drawer_triggered', !props.drawer)
    }

    function triggerUserDialog () {
      eventBus.emit('userDialogRef_triggered', true)
    }

    function triggerDrawerRight () {
      eventBus.emit('drawer_triggered_right', !props.drawerRight)
    }

    function languageSelected (identifier) {
      currentLanguage.value = languages.find(lang => lang.identifier === identifier)
    }

    function openWindow (url) {
      window.open(url, '_blank')
    }

    function openHomePage () {
      window.location.href = '/'
    }

    return {
      currentUserRef,
      languages,
      currentLanguage,
      defaultLanguageIdentifier,
      languageSelected,
      triggerDrawer,
      triggerUserDialog,
      triggerDrawerRight,
      openHomePage,
      openWindow,
      isExportSearch: props.export
    }
  }
}
</script>

<style>
  .pointer {
    cursor: pointer;
    margin: 20px;
  }
</style>
